import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import logger from 'utils/logger';

const log = logger.createLogger('AdminOrganizationsTableColumns');

export const tableColumns = (handleOpenOrgDetails, handleOpenDeleteOrg) => [
  {
    accessorKey: 'id',
    header: 'Organization Id',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'orgName',
    header: 'Organization Name',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'orgCode',
    header: 'Organization Code',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'owner',
    header: 'Owner',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'accelerateEnabled',
    header: 'S3 Accelerate',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
    Cell: ({ renderedCellValue }) => {
      if (renderedCellValue) {
        return <CheckCircleIcon color="success" />;
      }
      return <CancelIcon color="error" />;
    },
  },
  {
    accessorKey: 'cloudfrontEnabled',
    header: 'CloudFront',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
    Cell: ({ renderedCellValue }) => {
      if (renderedCellValue) {
        return <CheckCircleIcon color="success" />;
      }
      return <CancelIcon color="error" />;
    },
  },
  {
    accessorKey: 'details',
    header: 'Details',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return detailsCell({ renderedCellValue, handleOpenOrgDetails });
    },
  },
  {
    accessorKey: 'delete',
    header: 'Delete',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return deleteCell({ renderedCellValue, handleOpenDeleteOrg });
    },
  },
];

//! Language
const detailsCell = ({ renderedCellValue, handleOpenOrgDetails }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleOpenOrgDetails(renderedCellValue);
        }}>
        Details
      </Button>
    </div>
  );
};

detailsCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenOrgDetails: PropTypes.func.isRequired,
};

//! Language
const deleteCell = ({ renderedCellValue, handleOpenDeleteOrg }) => {
  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          handleOpenDeleteOrg(renderedCellValue);
        }}>
        Delete
      </Button>
    </div>
  );
};

deleteCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenDeleteOrg: PropTypes.func.isRequired,
};
